__turbopack_context__.v({
  "body": "sub-class-view-module__Y1Xyqa__body",
  "container": "sub-class-view-module__Y1Xyqa__container",
  "image": "sub-class-view-module__Y1Xyqa__image",
  "wrapper": "sub-class-view-module__Y1Xyqa__wrapper",
});
